<template>
  <div>
    <v-row align="center" justify="start">
      <v-col cols="12" sm="6" md="5" lg="4" xl="3" v-if="!hideUsers">
        <UsersDropDownList
        label="Assigned to"
          :userId="assignedToUserId"
          @userIdChange="handleUserIdChange"
          :clearable="true"
        ></UsersDropDownList>
      </v-col>
      <v-col cols="12" sm="3" md="3" lg="2">
        <SimpleDatePicker
          slot="datepicker"
          :value="targetDate"
          :label="`Target Date`"
          :clearable="true"
          @selected-date-change="handleDateChange"
        ></SimpleDatePicker>
      </v-col>
      <v-col cols="6" sm="3" md="4" lg="2" xl="1">
        <v-switch
          class="my-auto"
          v-model="complete"
          label="Completed"
          @change="handleCompleted"
        ></v-switch>
      </v-col>
      <v-col cols="6" sm="4" md="4" lg="3" xl="2" v-if="!hideMyTaskToggleButton">
        <v-switch
          class="my-auto"
          v-model="onlyMyTasks"
          label="Show Only My Tasks"
          @change="handleShowOnlyMyTask"
        ></v-switch>
      </v-col>
    </v-row>
    <v-row justify="end">
      <v-col cols="12" sm="6">
        <FilterButtons
          @search="handleSearchClick"
          @clear="handleClearClick"
        ></FilterButtons>
      </v-col>
    </v-row>
    <FilterButtonsSmall
      @search="handleSearchClick"
      @clear="handleClearClick"
    ></FilterButtonsSmall>
  </div>
</template>

<script>
import { mapFields } from '@/vueHelpers/vuex'
import { mapActions } from 'vuex'
import { UsersDropDownList } from '@/components/users'
import { SimpleDatePicker } from '@/components/shared/datePickers'
import { FilterButtons, FilterButtonsSmall } from '@/components/buttons'
import { getCurrentUser } from '@/lib/authentication'

export default {
  props: [
    'userId',
    'hideUsers',
    'hideMyTaskToggleButton'
  ],
  components: {
    UsersDropDownList,
    SimpleDatePicker,
    FilterButtons,
    FilterButtonsSmall
  },
  computed: {
    ...mapFields('todoFilters', [
      'assignedToUserId',
      'targetDate',
      'complete',
      'onlyMyTasks'
    ])
  },
  methods: {
    ...mapActions('todoFilters', [
      'clearFilters'
    ]),
    handleSearchClick () {
      this.$emit('search')
    },
    handleUserIdChange (value) {
      if (this.onlyMyTasks && value !== this.assignedToUserId) {
        this.onlyMyTasks = false
      }
      this.assignedToUserId = value
    },
    handleDateChange (newValue) {
      this.targetDate = newValue
    },
    handleCompleted (value) {
      this.complete = value
      this.handleSearchClick()
    },
    handleClearClick () {
      this.clearFilters(this.userId)
      this.$emit('clear')
    },
    handleShowOnlyMyTask () {
      if (this.onlyMyTasks) {
        this.assignedToUserId = getCurrentUser().id
      } else {
        this.assignedToUserId = null
      }
      this.handleSearchClick()
    }
  },
  created () {
    if (this.userId && this.userId > 0) {
      this.handleUserIdChange(this.userId)
    }
  }
}
</script>
